/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { DepositTypes } from "../models/depositTypes";

@Pipe({
  name: "depositTypeLabel"
})
export class DepositTypeLabelPipe implements PipeTransform {
  transform(value: string): string {
    return DepositTypes[value as keyof typeof DepositTypes];
  }
}
